<div class="search-window" [formGroup]="form">
  <div class="item top">
    <div class="item-header">Zoekterm</div>
    @if (!isMobile) {
      <mat-form-field class="profession" appearance="fill" >
        <input
          type="search"
          matInput
          placeholder="Functie"
          aria-label="Functie"
          formControlName="profession"
          [matAutocomplete]="auto1"
          #profTrigger="matAutocompleteTrigger"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (keydown.enter)="onKeyEnter($event, profTrigger)"
          />
        @if (form.get('profession')?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="clear-button"
            (click)="onClear($event, 'profession')"
            aria-label="Wissen"
            >
            <span class="visually-hidden">Wissen</span>
            <icon name="close"></icon>
          </button>
        }
        <mat-autocomplete
          #auto1="matAutocomplete"
          (optionSelected)="onSubmit()"
          >
          @for (option of professionOptions$ | async; track option) {
            <mat-option
              [value]="option"
            (touchend)="
              onOptionTouch(option, 'profession', profTrigger, $event)
            "
              >
              <span
                class="suggestion"
                [innerHTML]="highlightMatch(option, 'profession')"
              ></span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    } @else {
      <mat-form-field class="profession" appearance="fill" >
        <input
          type="search"
          matInput
          placeholder="Functie"
          aria-label="Functie"
          formControlName="profession"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (focus)="onFocus('profession')"
          (keydown.enter)="onKeyEnter($event)"
          />
        @if (form.get('profession')?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="clear-button"
            (click)="onClear($event, 'profession')"
            aria-label="Wissen"
            >
            <span class="visually-hidden">Wissen</span>
            <icon name="close"></icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
  <div class="item left">
    <div class="item-header">Locatie</div>
    @if (!isMobile) {
      <mat-form-field class="location" appearance="fill" >
        <input
          type="search"
          matInput
          placeholder="Stad of provincie"
          aria-label="Stad of provincie"
          formControlName="location"
          [matAutocomplete]="auto"
          #locTrigger="matAutocompleteTrigger"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (keydown.enter)="onKeyEnter($event, locTrigger)"
          />
        @if (form.get('location')?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="clear-button"
            (click)="onClear($event, 'location')"
            aria-label="Wissen"
            >
            <span class="visually-hidden">Wissen</span>
            <icon name="close"></icon>
          </button>
        }
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSubmit()">
          @for (option of locationOptions$ | async; track option) {
            <mat-option
              [value]="option"
              (touchend)="onOptionTouch(option, 'location', locTrigger, $event)"
              >
              <span
                class="suggestion"
                [innerHTML]="highlightMatch(option, 'location')"
              ></span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    } @else {
      <mat-form-field class="location" appearance="fill" >
        <input
          type="search"
          matInput
          placeholder="Stad of provincie"
          aria-label="Stad of provincie"
          formControlName="location"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (focus)="onFocus('location')"
          (keydown.enter)="onKeyEnter($event)"
          />
        @if (form.get('location')?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="clear-button"
            (click)="onClear($event, 'location')"
            aria-label="Wissen"
            >
            <span class="visually-hidden">Wissen</span>
            <icon name="close"></icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
  <div class="item bottom">
    <div class="item-header"></div>
    <button
      type="button"
      class="apple-cta apple-cta--blue"
      (click)="onSubmit()"
      >
      <span>Zoeken</span>
      <icon name="search"></icon>
    </button>
  </div>
</div>

<ng-template #mobileOverlay>
  <div class="mobile-search-overlay" [formGroup]="form">
    <div class="overlay-header">
      <div class="overlay-top-row">
        <button
          class="overlay-back"
          type="button"
          (click)="onOverlayClose()"
          aria-label="Terug"
          >
          <icon name="navigate_next" class="back-icon"></icon>
        </button>
        <mat-form-field
          class="overlay-input translate-y-[14px]"
          appearance="fill"

          >
          <input
            #overlayInput
            type="search"
            matInput
            [placeholder]="
              activeControl === 'profession' ? 'Functie' : 'Stad of provincie'
            "
            [formControlName]="activeControl"
            inputmode="search"
            enterkeyhint="search"
            autocomplete="off"
            autocapitalize="off"
            spellcheck="false"
            (keydown.enter)="onOverlaySearch()"
            />
          @if (form.get(activeControl!)?.value) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              class="clear-button"
              (click)="onClear($event, activeControl!)"
              aria-label="Wissen"
              >
              <span class="visually-hidden">Wissen</span>
              <icon name="close"></icon>
            </button>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="overlay-suggestions-header">Zoeksuggesties</div>
    <div class="overlay-suggestions" [attr.data-type]="activeControl">
      @if (activeControl === 'profession') {
        @for (option of professionOptions$ | async; track option) {
          <button
            class="overlay-option"
            type="button"
            (click)="onOverlayOptionClick(option)"
            >
            <span class="opt-icon"><icon name="search"></icon></span>
            <span
              class="suggestion"
              [innerHTML]="highlightMatch(option, 'profession')"
            ></span>
          </button>
        }
      } @else {
        @for (option of locationOptions$ | async; track option) {
          <button
            class="overlay-option"
            type="button"
            (click)="onOverlayOptionClick(option)"
            >
            <span class="opt-icon"><icon name="search"></icon></span>
            <span
              class="suggestion"
              [innerHTML]="highlightMatch(option, 'location')"
            ></span>
          </button>
        }
      }
    </div>
  </div>
</ng-template>
